import { render } from "./QueuingIndex.vue?vue&type=template&id=6f50904c"
import script from "./QueuingIndex.vue?vue&type=script&lang=js"
export * from "./QueuingIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__